import { initialState } from "./state"

export default {
  setUuid: (state, payload) => (state.uuid = payload),
  setIsEditing: (state, payload) => (state.isEditing = payload),
  setCurrentStep: (state, payload) => (state.currentStep = payload),
  setSteps: (state, payload) => (state.steps = payload),
  setStepNameRoutes: (state, payload) => (state.step_name_routes = payload),
  setLoading: (state, payload) => (state.loading = payload),
  updateIndexStepsAlreadyVisited: (state, payload) =>
    (state.indexStepsAlreadyVisited = payload),
  updatePreviousRoute: (state, payload) => (state.previousRoute = payload),

  setTitle: (state, payload) => (state.report.title = payload),
  setPublicationDate: (state, payload) =>
    (state.report.publicationDate = payload),
  setExpirationDate: (state, payload) =>
    (state.report.expirationDate = payload),
  setRead: (state, payload) => (state.report.read = payload),
  setText: (state, payload) => (state.report.text = payload),
  setActive: (state, payload) => (state.report.active = payload),
  setProviderId: (state, payload) => (state.report.providerId = payload),
  setUploads: (state, payload) => (state.report.uploads = payload),
  setFormatedUploads: (state, payload) =>
    (state.report.formatedUploads = payload),

  setNewFiles: (state, payload) => (state.report.newFiles = payload),
  setDeletedFilesIds: (state, payload) =>
    (state.report.deletedFilesIds = payload),

  setRoles: (state, payload) => (state.report.role.roles = payload),
  setIsAllRoles: (state, payload) => (state.report.role.isAllRoles = payload),

  setChains: (state, payload) => (state.report.chain.chains = payload),
  setIsAllChains: (state, payload) =>
    (state.report.chain.isAllChains = payload),

  setPdvs: (state, payload) => (state.report.pdvs = payload),

  setFilterTitle: (state, payload) => (state.filter.title = payload),
  setFilterPublicationDate: (state, payload) =>
    (state.filter.publicationDate = payload),
  setFilters: (state, payload) => (state.filters = payload),

  setReport: (state, payload) => (state.report = payload),
  updateReport: (state, payload) =>
    (state.report = { ...state.report, ...payload }),
  clearReportStore: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
